/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createELAdminEventLog = /* GraphQL */ `
  mutation CreateELAdminEventLog(
    $input: CreateELAdminEventLogInput!
    $condition: ModelELAdminEventLogConditionInput
  ) {
    createELAdminEventLog(input: $input, condition: $condition) {
      adminUser
      timestamp
      action
      exchangeInstrument
      tradeAccount
      symbol
      balance
      leverage
      targetAdminUser
      permission
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateELAdminEventLog = /* GraphQL */ `
  mutation UpdateELAdminEventLog(
    $input: UpdateELAdminEventLogInput!
    $condition: ModelELAdminEventLogConditionInput
  ) {
    updateELAdminEventLog(input: $input, condition: $condition) {
      adminUser
      timestamp
      action
      exchangeInstrument
      tradeAccount
      symbol
      balance
      leverage
      targetAdminUser
      permission
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteELAdminEventLog = /* GraphQL */ `
  mutation DeleteELAdminEventLog(
    $input: DeleteELAdminEventLogInput!
    $condition: ModelELAdminEventLogConditionInput
  ) {
    deleteELAdminEventLog(input: $input, condition: $condition) {
      adminUser
      timestamp
      action
      exchangeInstrument
      tradeAccount
      symbol
      balance
      leverage
      targetAdminUser
      permission
      description
      createdAt
      updatedAt
    }
  }
`;
export const createModelBacktestKPI = /* GraphQL */ `
  mutation CreateModelBacktestKPI(
    $input: CreateModelBacktestKPIInput!
    $condition: ModelModelBacktestKPIConditionInput
  ) {
    createModelBacktestKPI(input: $input, condition: $condition) {
      symbol
      timestamp_15mPointNum
      description
      interval
      exchange
      timestamp
      datetime
      fifteenMinPointNum
      leverage
      testPointNumber
      cumulativeReturn
      cumulativePositionChange
      cumulativeReturn1BPS
      cumulativeReturn1_5BPS
      cumulativeReturn2BPS
      cumulativeReturn3BPS
      leverageReturn
      profitPercent
      dailyGrowthRate
      volatility
      sharpeRatio
      sortinoRatio
      maxDrawDown
      calmarRatio
      modelName1
      modelName2
      isDeactivated
    }
  }
`;
export const updateModelBacktestKPI = /* GraphQL */ `
  mutation UpdateModelBacktestKPI(
    $input: UpdateModelBacktestKPIInput!
    $condition: ModelModelBacktestKPIConditionInput
  ) {
    updateModelBacktestKPI(input: $input, condition: $condition) {
      symbol
      timestamp_15mPointNum
      description
      interval
      exchange
      timestamp
      datetime
      fifteenMinPointNum
      leverage
      testPointNumber
      cumulativeReturn
      cumulativePositionChange
      cumulativeReturn1BPS
      cumulativeReturn1_5BPS
      cumulativeReturn2BPS
      cumulativeReturn3BPS
      leverageReturn
      profitPercent
      dailyGrowthRate
      volatility
      sharpeRatio
      sortinoRatio
      maxDrawDown
      calmarRatio
      modelName1
      modelName2
      isDeactivated
    }
  }
`;
export const deleteModelBacktestKPI = /* GraphQL */ `
  mutation DeleteModelBacktestKPI(
    $input: DeleteModelBacktestKPIInput!
    $condition: ModelModelBacktestKPIConditionInput
  ) {
    deleteModelBacktestKPI(input: $input, condition: $condition) {
      symbol
      timestamp_15mPointNum
      description
      interval
      exchange
      timestamp
      datetime
      fifteenMinPointNum
      leverage
      testPointNumber
      cumulativeReturn
      cumulativePositionChange
      cumulativeReturn1BPS
      cumulativeReturn1_5BPS
      cumulativeReturn2BPS
      cumulativeReturn3BPS
      leverageReturn
      profitPercent
      dailyGrowthRate
      volatility
      sharpeRatio
      sortinoRatio
      maxDrawDown
      calmarRatio
      modelName1
      modelName2
      isDeactivated
    }
  }
`;
export const createTradeSymbols = /* GraphQL */ `
  mutation CreateTradeSymbols(
    $input: CreateTradeSymbolsInput!
    $condition: ModelTradeSymbolsConditionInput
  ) {
    createTradeSymbols(input: $input, condition: $condition) {
      symbol
      lastPredictedAt
      isVolatileSymbol
      binanceUsdsFutureContractDecimal
      binanceCoinFutureContractDecimal
      huobiUsdtSwapContractDecimal
      huobiCoinSwapContractDecimal
      huobiFutureContractDecimal
      ifFetchForPrediction
      ifFetchForTraining
      ifRunScheduledEvaluation
      ifDisplayInAdmin
    }
  }
`;
export const updateTradeSymbols = /* GraphQL */ `
  mutation UpdateTradeSymbols(
    $input: UpdateTradeSymbolsInput!
    $condition: ModelTradeSymbolsConditionInput
  ) {
    updateTradeSymbols(input: $input, condition: $condition) {
      symbol
      lastPredictedAt
      isVolatileSymbol
      binanceUsdsFutureContractDecimal
      binanceCoinFutureContractDecimal
      huobiUsdtSwapContractDecimal
      huobiCoinSwapContractDecimal
      huobiFutureContractDecimal
      ifFetchForPrediction
      ifFetchForTraining
      ifRunScheduledEvaluation
      ifDisplayInAdmin
    }
  }
`;
export const deleteTradeSymbols = /* GraphQL */ `
  mutation DeleteTradeSymbols(
    $input: DeleteTradeSymbolsInput!
    $condition: ModelTradeSymbolsConditionInput
  ) {
    deleteTradeSymbols(input: $input, condition: $condition) {
      symbol
      lastPredictedAt
      isVolatileSymbol
      binanceUsdsFutureContractDecimal
      binanceCoinFutureContractDecimal
      huobiUsdtSwapContractDecimal
      huobiCoinSwapContractDecimal
      huobiFutureContractDecimal
      ifFetchForPrediction
      ifFetchForTraining
      ifRunScheduledEvaluation
      ifDisplayInAdmin
    }
  }
`;
export const createExchangeAccountBalance = /* GraphQL */ `
  mutation CreateExchangeAccountBalance(
    $input: CreateExchangeAccountBalanceInput!
    $condition: ModelExchangeAccountBalanceConditionInput
  ) {
    createExchangeAccountBalance(input: $input, condition: $condition) {
      exchangeAccount
      timestamp
      type
      parentAccount
      balances
      tradeSessions
    }
  }
`;
export const updateExchangeAccountBalance = /* GraphQL */ `
  mutation UpdateExchangeAccountBalance(
    $input: UpdateExchangeAccountBalanceInput!
    $condition: ModelExchangeAccountBalanceConditionInput
  ) {
    updateExchangeAccountBalance(input: $input, condition: $condition) {
      exchangeAccount
      timestamp
      type
      parentAccount
      balances
      tradeSessions
    }
  }
`;
export const deleteExchangeAccountBalance = /* GraphQL */ `
  mutation DeleteExchangeAccountBalance(
    $input: DeleteExchangeAccountBalanceInput!
    $condition: ModelExchangeAccountBalanceConditionInput
  ) {
    deleteExchangeAccountBalance(input: $input, condition: $condition) {
      exchangeAccount
      timestamp
      type
      parentAccount
      balances
      tradeSessions
    }
  }
`;
export const createCognitoAdminPermission = /* GraphQL */ `
  mutation CreateCognitoAdminPermission(
    $input: CreateCognitoAdminPermissionInput!
    $condition: ModelCognitoAdminPermissionConditionInput
  ) {
    createCognitoAdminPermission(input: $input, condition: $condition) {
      email
      isEnabled
      username
      groups
      role
      managedAccounts {
        name
        permissions
      }
      enabledPermissions
      tradeAccountGroups {
        name
        includedAccounts
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCognitoAdminPermission = /* GraphQL */ `
  mutation UpdateCognitoAdminPermission(
    $input: UpdateCognitoAdminPermissionInput!
    $condition: ModelCognitoAdminPermissionConditionInput
  ) {
    updateCognitoAdminPermission(input: $input, condition: $condition) {
      email
      isEnabled
      username
      groups
      role
      managedAccounts {
        name
        permissions
      }
      enabledPermissions
      tradeAccountGroups {
        name
        includedAccounts
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCognitoAdminPermission = /* GraphQL */ `
  mutation DeleteCognitoAdminPermission(
    $input: DeleteCognitoAdminPermissionInput!
    $condition: ModelCognitoAdminPermissionConditionInput
  ) {
    deleteCognitoAdminPermission(input: $input, condition: $condition) {
      email
      isEnabled
      username
      groups
      role
      managedAccounts {
        name
        permissions
      }
      enabledPermissions
      tradeAccountGroups {
        name
        includedAccounts
      }
      createdAt
      updatedAt
    }
  }
`;
export const createTradeAccountStatus = /* GraphQL */ `
  mutation CreateTradeAccountStatus(
    $input: CreateTradeAccountStatusInput!
    $condition: ModelTradeAccountStatusConditionInput
  ) {
    createTradeAccountStatus(input: $input, condition: $condition) {
      exchange
      accountSymbol
      sessionName
      contactNumbers
      type
      isTrading
      enableMonitoring
      executingCommand
      status
      symbol
      modes
      configs
      leverage
      practicalLeverage
      leverageScaleFactor
      currentState
      errorMessage
      walletBalance
      marginBalance
      usedBalance
      entireBalanceList
      parentAccount
      algoParams
      algoTrades
      info
      arbitrageMarginAmt
      arbitrageUsdmAmt
      arbitrageParams
      tradingHoursParams
      createdAt
      updatedAt
    }
  }
`;
export const updateTradeAccountStatus = /* GraphQL */ `
  mutation UpdateTradeAccountStatus(
    $input: UpdateTradeAccountStatusInput!
    $condition: ModelTradeAccountStatusConditionInput
  ) {
    updateTradeAccountStatus(input: $input, condition: $condition) {
      exchange
      accountSymbol
      sessionName
      contactNumbers
      type
      isTrading
      enableMonitoring
      executingCommand
      status
      symbol
      modes
      configs
      leverage
      practicalLeverage
      leverageScaleFactor
      currentState
      errorMessage
      walletBalance
      marginBalance
      usedBalance
      entireBalanceList
      parentAccount
      algoParams
      algoTrades
      info
      arbitrageMarginAmt
      arbitrageUsdmAmt
      arbitrageParams
      tradingHoursParams
      createdAt
      updatedAt
    }
  }
`;
export const deleteTradeAccountStatus = /* GraphQL */ `
  mutation DeleteTradeAccountStatus(
    $input: DeleteTradeAccountStatusInput!
    $condition: ModelTradeAccountStatusConditionInput
  ) {
    deleteTradeAccountStatus(input: $input, condition: $condition) {
      exchange
      accountSymbol
      sessionName
      contactNumbers
      type
      isTrading
      enableMonitoring
      executingCommand
      status
      symbol
      modes
      configs
      leverage
      practicalLeverage
      leverageScaleFactor
      currentState
      errorMessage
      walletBalance
      marginBalance
      usedBalance
      entireBalanceList
      parentAccount
      algoParams
      algoTrades
      info
      arbitrageMarginAmt
      arbitrageUsdmAmt
      arbitrageParams
      tradingHoursParams
      createdAt
      updatedAt
    }
  }
`;
export const createMonitoringAccounts = /* GraphQL */ `
  mutation CreateMonitoringAccounts(
    $input: CreateMonitoringAccountsInput!
    $condition: ModelMonitoringAccountsConditionInput
  ) {
    createMonitoringAccounts(input: $input, condition: $condition) {
      exchange
      account
      alertNumbers
      disableMonitor
      symbols
      parentAccount
      type
    }
  }
`;
export const updateMonitoringAccounts = /* GraphQL */ `
  mutation UpdateMonitoringAccounts(
    $input: UpdateMonitoringAccountsInput!
    $condition: ModelMonitoringAccountsConditionInput
  ) {
    updateMonitoringAccounts(input: $input, condition: $condition) {
      exchange
      account
      alertNumbers
      disableMonitor
      symbols
      parentAccount
      type
    }
  }
`;
export const deleteMonitoringAccounts = /* GraphQL */ `
  mutation DeleteMonitoringAccounts(
    $input: DeleteMonitoringAccountsInput!
    $condition: ModelMonitoringAccountsConditionInput
  ) {
    deleteMonitoringAccounts(input: $input, condition: $condition) {
      exchange
      account
      alertNumbers
      disableMonitor
      symbols
      parentAccount
      type
    }
  }
`;
export const createModelPrediction = /* GraphQL */ `
  mutation CreateModelPrediction(
    $input: CreateModelPredictionInput!
    $condition: ModelModelPredictionConditionInput
  ) {
    createModelPrediction(input: $input, condition: $condition) {
      modelName
      timeStamp
      predictValue
      interval
      intervalInMillisec
      symbol
      targetModelId
    }
  }
`;
export const updateModelPrediction = /* GraphQL */ `
  mutation UpdateModelPrediction(
    $input: UpdateModelPredictionInput!
    $condition: ModelModelPredictionConditionInput
  ) {
    updateModelPrediction(input: $input, condition: $condition) {
      modelName
      timeStamp
      predictValue
      interval
      intervalInMillisec
      symbol
      targetModelId
    }
  }
`;
export const deleteModelPrediction = /* GraphQL */ `
  mutation DeleteModelPrediction(
    $input: DeleteModelPredictionInput!
    $condition: ModelModelPredictionConditionInput
  ) {
    deleteModelPrediction(input: $input, condition: $condition) {
      modelName
      timeStamp
      predictValue
      interval
      intervalInMillisec
      symbol
      targetModelId
    }
  }
`;
export const createTradeModels = /* GraphQL */ `
  mutation CreateTradeModels(
    $input: CreateTradeModelsInput!
    $condition: ModelTradeModelsConditionInput
  ) {
    createTradeModels(input: $input, condition: $condition) {
      modelName1
      modelName2
      disabled
      symbol
      temporarilyDisabledSymbols
      tradingSymbols
    }
  }
`;
export const updateTradeModels = /* GraphQL */ `
  mutation UpdateTradeModels(
    $input: UpdateTradeModelsInput!
    $condition: ModelTradeModelsConditionInput
  ) {
    updateTradeModels(input: $input, condition: $condition) {
      modelName1
      modelName2
      disabled
      symbol
      temporarilyDisabledSymbols
      tradingSymbols
    }
  }
`;
export const deleteTradeModels = /* GraphQL */ `
  mutation DeleteTradeModels(
    $input: DeleteTradeModelsInput!
    $condition: ModelTradeModelsConditionInput
  ) {
    deleteTradeModels(input: $input, condition: $condition) {
      modelName1
      modelName2
      disabled
      symbol
      temporarilyDisabledSymbols
      tradingSymbols
    }
  }
`;
export const createPartnerPrediction = /* GraphQL */ `
  mutation CreatePartnerPrediction(
    $input: CreatePartnerPredictionInput!
    $condition: ModelPartnerPredictionConditionInput
  ) {
    createPartnerPrediction(input: $input, condition: $condition) {
      modelName
      timestamp
      data
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updatePartnerPrediction = /* GraphQL */ `
  mutation UpdatePartnerPrediction(
    $input: UpdatePartnerPredictionInput!
    $condition: ModelPartnerPredictionConditionInput
  ) {
    updatePartnerPrediction(input: $input, condition: $condition) {
      modelName
      timestamp
      data
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deletePartnerPrediction = /* GraphQL */ `
  mutation DeletePartnerPrediction(
    $input: DeletePartnerPredictionInput!
    $condition: ModelPartnerPredictionConditionInput
  ) {
    deletePartnerPrediction(input: $input, condition: $condition) {
      modelName
      timestamp
      data
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createTouchstoneSubmissions = /* GraphQL */ `
  mutation CreateTouchstoneSubmissions(
    $input: CreateTouchstoneSubmissionsInput!
    $condition: ModelTouchstoneSubmissionsConditionInput
  ) {
    createTouchstoneSubmissions(input: $input, condition: $condition) {
      system
      submission_id
      gsi_pk
      owner
      sources
      status
      queue_position
      results
      description
      ts_created
      ts_queued
      ts_finished
      console_log_tail
    }
  }
`;
export const updateTouchstoneSubmissions = /* GraphQL */ `
  mutation UpdateTouchstoneSubmissions(
    $input: UpdateTouchstoneSubmissionsInput!
    $condition: ModelTouchstoneSubmissionsConditionInput
  ) {
    updateTouchstoneSubmissions(input: $input, condition: $condition) {
      system
      submission_id
      gsi_pk
      owner
      sources
      status
      queue_position
      results
      description
      ts_created
      ts_queued
      ts_finished
      console_log_tail
    }
  }
`;
export const deleteTouchstoneSubmissions = /* GraphQL */ `
  mutation DeleteTouchstoneSubmissions(
    $input: DeleteTouchstoneSubmissionsInput!
    $condition: ModelTouchstoneSubmissionsConditionInput
  ) {
    deleteTouchstoneSubmissions(input: $input, condition: $condition) {
      system
      submission_id
      gsi_pk
      owner
      sources
      status
      queue_position
      results
      description
      ts_created
      ts_queued
      ts_finished
      console_log_tail
    }
  }
`;
export const createTouchstoneTasks = /* GraphQL */ `
  mutation CreateTouchstoneTasks(
    $input: CreateTouchstoneTasksInput!
    $condition: ModelTouchstoneTasksConditionInput
  ) {
    createTouchstoneTasks(input: $input, condition: $condition) {
      submission_id
      task_id
      gsi_pk
      artifacts
      desired_resource
      resource
      config_file
      el_nigma_branch
      sources
      pred_interval
      fetched_data_end_to
      passthrough_args
      status
      status_timestamp
      epochs_completed
      epochs_timestamp
      console_log_tail
      console_log_url
      ts_task_started
      ts_task_finished
      ts_training_started
      ts_training_finished
      type
    }
  }
`;
export const updateTouchstoneTasks = /* GraphQL */ `
  mutation UpdateTouchstoneTasks(
    $input: UpdateTouchstoneTasksInput!
    $condition: ModelTouchstoneTasksConditionInput
  ) {
    updateTouchstoneTasks(input: $input, condition: $condition) {
      submission_id
      task_id
      gsi_pk
      artifacts
      desired_resource
      resource
      config_file
      el_nigma_branch
      sources
      pred_interval
      fetched_data_end_to
      passthrough_args
      status
      status_timestamp
      epochs_completed
      epochs_timestamp
      console_log_tail
      console_log_url
      ts_task_started
      ts_task_finished
      ts_training_started
      ts_training_finished
      type
    }
  }
`;
export const deleteTouchstoneTasks = /* GraphQL */ `
  mutation DeleteTouchstoneTasks(
    $input: DeleteTouchstoneTasksInput!
    $condition: ModelTouchstoneTasksConditionInput
  ) {
    deleteTouchstoneTasks(input: $input, condition: $condition) {
      submission_id
      task_id
      gsi_pk
      artifacts
      desired_resource
      resource
      config_file
      el_nigma_branch
      sources
      pred_interval
      fetched_data_end_to
      passthrough_args
      status
      status_timestamp
      epochs_completed
      epochs_timestamp
      console_log_tail
      console_log_url
      ts_task_started
      ts_task_finished
      ts_training_started
      ts_training_finished
      type
    }
  }
`;
export const createSystemConfig = /* GraphQL */ `
  mutation CreateSystemConfig(
    $input: CreateSystemConfigInput!
    $condition: ModelSystemConfigConditionInput
  ) {
    createSystemConfig(input: $input, condition: $condition) {
      category
      keyname
      value
    }
  }
`;
export const updateSystemConfig = /* GraphQL */ `
  mutation UpdateSystemConfig(
    $input: UpdateSystemConfigInput!
    $condition: ModelSystemConfigConditionInput
  ) {
    updateSystemConfig(input: $input, condition: $condition) {
      category
      keyname
      value
    }
  }
`;
export const deleteSystemConfig = /* GraphQL */ `
  mutation DeleteSystemConfig(
    $input: DeleteSystemConfigInput!
    $condition: ModelSystemConfigConditionInput
  ) {
    deleteSystemConfig(input: $input, condition: $condition) {
      category
      keyname
      value
    }
  }
`;
export const startTradeInSession = /* GraphQL */ `
  mutation StartTradeInSession(
    $query: MutationStartTradeInSessionQueryInput
    $body: MutationStartTradeInSessionBodyInput
  ) {
    startTradeInSession(query: $query, body: $body) {
      response
    }
  }
`;
export const stopTradeInSession = /* GraphQL */ `
  mutation StopTradeInSession(
    $query: MutationStopTradeInSessionQueryInput
    $body: MutationStopTradeInSessionBodyInput
  ) {
    stopTradeInSession(query: $query, body: $body) {
      response
    }
  }
`;
export const closePositionInSession = /* GraphQL */ `
  mutation ClosePositionInSession(
    $query: MutationClosePositionInSessionQueryInput
    $body: MutationClosePositionInSessionBodyInput
  ) {
    closePositionInSession(query: $query, body: $body) {
      response
    }
  }
`;
export const setLeverage = /* GraphQL */ `
  mutation SetLeverage(
    $query: MutationSetLeverageQueryInput
    $body: MutationSetLeverageBodyInput
  ) {
    setLeverage(query: $query, body: $body) {
      response
    }
  }
`;
export const createTradeAccount = /* GraphQL */ `
  mutation CreateTradeAccount(
    $query: MutationCreateTradeAccountQueryInput
    $body: MutationCreateTradeAccountBodyInput
  ) {
    createTradeAccount(query: $query, body: $body) {
      response
    }
  }
`;
export const deleteTradeAccount = /* GraphQL */ `
  mutation DeleteTradeAccount(
    $query: MutationDeleteTradeAccountQueryInput
    $body: MutationDeleteTradeAccountBodyInput
  ) {
    deleteTradeAccount(query: $query, body: $body) {
      response
    }
  }
`;
export const transferWalletFund = /* GraphQL */ `
  mutation TransferWalletFund(
    $query: MutationTransferWalletFundQueryInput
    $body: MutationTransferWalletFundBodyInput
  ) {
    transferWalletFund(query: $query, body: $body)
  }
`;
export const updateApiKeys = /* GraphQL */ `
  mutation UpdateApiKeys(
    $exchangeAccount: String!
    $readApiKey: String
    $readApiSecret: String
    $readApiPassword: String
    $tradeApiKey: String
    $tradeApiSecret: String
    $tradeApiPassword: String
  ) {
    updateApiKeys(
      exchangeAccount: $exchangeAccount
      readApiKey: $readApiKey
      readApiSecret: $readApiSecret
      readApiPassword: $readApiPassword
      tradeApiKey: $tradeApiKey
      tradeApiSecret: $tradeApiSecret
      tradeApiPassword: $tradeApiPassword
    )
  }
`;
export const publishEvent = /* GraphQL */ `
  mutation PublishEvent($name: String!, $timestamp: String!, $data: AWSJSON) {
    publishEvent(name: $name, timestamp: $timestamp, data: $data) {
      name
      timestamp
      data
    }
  }
`;
